import { ReportEntry } from '../../../../../../domain/report/ReportEntry';

export const reportCompositionValue = (reportEntry: ReportEntry): number =>
  reportEntry.compositionValue;
